import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/features/auth';

/**
 * Rota raiz `/` — redireciona conforme estado de auth.
 * Sem componente próprio (loader resolve + redirect).
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const isAuth = useAuthStore.getState().isAuthenticated;
    throw redirect({ to: isAuth ? '/app/dashboard' : '/login' });
  },
});
